import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Button, Form, Alert, Row, Col } from 'react-bootstrap';
import { MenuItem } from '@material-ui/core';
import ReduxQuill from "../common/ReduxQuill";
import { TextField } from "../common/FormComponents";
import {toArray} from "../common/util";
import {hasGroup} from "../common/permissions";

const validate = values => {
    const errors = {};
    if (values.codex === "<p><br></p>" || values.codex === "<p></p>" || !values.codex) {
        errors.codex = '* Cannot be blank';
    }
    if (!values.title) {
        errors.title = '* Required';
    }
    if (!values.parent) {
        errors.parent = '* Required';
    }
    if (!values.restrictionLevel) {
        errors.restrictionLevel = '* Required';
    }
    if (values.order < 0) {
        errors.order = '* Positive Integer Required';
    }
    return errors
};

const normalize = (value, previousValue) => {
    if (!value) {
        return value
    }
    const onlyNums = value.replace(/[^\d]/g, '')
    if (onlyNums > 9999) {
        return 9999
    }
    if (onlyNums.length <= 4) {
        return Number(onlyNums)
    }

    return Number(onlyNums.slice(0, 3))
};

const CodexForm = props => {
    const onKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };
    const { handleSubmit, editToggle } = props;
    function submit(event) {
        handleSubmit();
        if (editToggle)
            editToggle();
    }
    return (
        <Form onSubmit={props.handleSubmit}>
            <Row>
                <Col md={12}>
                    <Field component={TextField}
                        name="title"
                        type="text"
                        label="Title"
                        helperText={<span></span>}
                        onKeyPress={onKeyPress}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Field component={ReduxQuill}
                        name="codex"
                    />
                    { props.errors ? (
                        <Alert bsStyle="danger">An Error occured.</Alert>
                        ) : null
                    }
                </Col>
            </Row>
            <Row>
                <Col md={2}>
                    <Field component={TextField}
                        name="parent"
                        select
                        fullWidth
                        label="Parent Page"
                        helperText={<span></span>}
                    >
                        <MenuItem key="none" value="None">None</MenuItem>
                        {toArray(props.codex.data)
                        .filter(codex => codex.title !== props.initialValues.title)
                        .sort((a, b) => a.order - b.order)
                        .map((codex) => (
                            <MenuItem key={codex.id} value={codex.id}>{codex.parent ? "-"+codex.title : codex.title}</MenuItem>
                        ))}
                    </Field>
                </Col>
                <Col md={2}>
                    <Field component={TextField}
                        name="restrictionLevel"
                        select
                        fullWidth
                        label="Restrict to"
                        helperText={<span></span>}
                    >
                        <MenuItem key="public" value="Public">Public</MenuItem>
                        { hasGroup('Member', props.auth.groups) ? <MenuItem key="Member" value="Member">Member</MenuItem> : null }
                        { hasGroup('Officer', props.auth.groups) ? <MenuItem key="Officer" value="Officer">Officer</MenuItem> : null }
                    </Field>
                </Col>
                <Col md={2}>
                    <Field component={TextField}
                        name="order"
                        type="text"
                        label="Order"
                        helperText={<span></span>}
                        normalize={normalize}
                        onKeyPress={onKeyPress}
                    />
                </Col>
                <Col md={2}>
                    <Button style={{marginTop:"5px"}} onClick={submit} disabled={props.pristine || props.pending}>Save</Button>
                </Col>
            </Row>
        </Form>
    )
};

export default reduxForm({
    form: 'codex',
    enableReinitialize: true,
    validate })(CodexForm)



// WEBPACK FOOTER //
// ./src/Media/CodexForm.js